import React, { useContext, useState, useEffect, useRef } from 'react';
import "./navbar.css";

import NavContext from '../../contexts/NavContext';
import Logo from '../../assets/images/Mask group.png';
import ArrowDown from '../../assets/icons/arrow-down.svg';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
// import PopupDisplay from '../popup/popup'
import { useLocation, Link, useNavigate } from 'react-router-dom';
import debounce from 'lodash.debounce';
import { Dialog } from 'primereact/dialog';
import LoginComponent from '../../components/login/login'
import RegisterComponent from '../../components/register/register'
import BasketLayout from '../basket/basket'
import { Menu } from 'primereact/menu';
import Loader from '../../components/loader/dotloader'


//icon
import Profile from '../../assets/icons/profile.svg';
import ProfileSolid from '../../assets/icons/profile-solid.svg';
import PersonalCardSolid from '../../assets/icons/personal-card-solid.svg';
import PersonalCard from '../../assets/icons/personal-card.svg';
import Shop from '../../assets/icons/menu/shop.svg'
import Blog from '../../assets/icons/menu/blog.svg'
import Headphone from '../../assets/icons/menu/headphone.svg'
import User from '../../assets/icons/menu/user.svg'
import Message from '../../assets/icons/menu/message.svg'
import Notif from '../../assets/icons/menu/notif.svg'
import Heart from '../../assets/icons/menu/heart.svg'
import Logout from '../../assets/icons/menu/logout.svg'
import Home from '../../assets/icons/menu/home.svg'
import Search from '../../assets/icons/search.svg'
import Basket from '../../assets/icons/shop-card.svg'
import { Skeleton } from 'primereact/skeleton';
import MenuIcon from '../../assets/icons/menu/menu.svg';
import { GetListPack, GetListGroupKala, GetProductByCategory, GetProductsbBySearch } from '../../utils/api';
import BasketIcon from '../../assets/icons/menu/shopIcon.svg'
import Report from '../../assets/icons/menu/report.svg';
import Card from '../../assets/icons/menu/card.svg';


//active
import HomeActive from '../../assets/icons/menu/active/home.svg';
import BasketActive from '../../assets/icons/menu/active/basket.svg';
import MessageActive from '../../assets/icons/menu/active/ticket.svg';
import NotifActive from '../../assets/icons/menu/active/notif.svg';
import HeartActive from '../../assets/icons/menu/active/heart.svg';
import UserActive from '../../assets/icons/menu/active/profile.svg';
import LocationActive from '../../assets/icons/menu/active/location.svg';
import ShopActive from '../../assets/icons/menu/active/shop.svg';
import HeadphoneActive from '../../assets/icons/menu/active/headphone.svg';
const NavbarComponent = () => {
  const [visibleRight, setVisibleRight] = useState(false);
  // const [noPopup, setNoPopup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [packProducts, setPackProducts] = useState([]);
  // const [popup, setPopup] = useState([]);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isPacksOpen, setIsPacksOpen] = useState(false);
  const [sectionLogin, setSectionLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [productLoading, setproductLoading] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [visible, setVisible] = useState(false); // Dialog visibility state
  const navigate = useNavigate(); // useNavigate for navigation without refresh
  const menuLeft = useRef(null);


  const { setNav } = useContext(NavContext);
  const changeNav = (name) => setNav(name);



  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [hoveredPack, setHoveredPack] = useState(null);
  let timeoutId = null;

  const handleMouseEnterCategory = (categoryId) => {
    // حذف تایمر قبلی (اگر کاربر قبل از 1 ثانیه دسته دیگری را هاور کند)
    if (timeoutId) clearTimeout(timeoutId);

    // شروع لودینگ
    setproductLoading(true);

    // تأخیر ۱ ثانیه‌ای برای ارسال درخواست
    timeoutId = setTimeout(async () => {
      try {
        const data = await GetProductByCategory({ productGroupId: categoryId });
        setProducts(data.data);

      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setproductLoading(false); // پایان لودینگ
      }
    }, 1000);
  };

  const handleMouseEnterPack = (categoryId) => {
    // حذف تایمر قبلی (اگر کاربر قبل از 1 ثانیه دسته دیگری را هاور کند)
    if (timeoutId) clearTimeout(timeoutId);

    // شروع لودینگ
    setproductLoading(true);

    // تأخیر ۱ ثانیه‌ای برای ارسال درخواست
    timeoutId = setTimeout(async () => {
      try {
        const data = await GetProductByCategory({ productGroupId: categoryId });
        setPackProducts(data.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setproductLoading(false); // پایان لودینگ
      }
    }, 1000);
  };


  const [categoriesPackage, setCategoriesPackage] = useState([]);
  const loadCategoriesWithProducts = async () => {
    try {
      setLoading(true)
      let data = await GetListGroupKala();
      setCategoriesPackage(data.data);

      let res = await GetListPack();
      setPack(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };



  const [pack, setPack] = useState([]);

  useEffect(() => {
    setTimeout(() => {

      loadCategoriesWithProducts();
    }, 2000);


  }, []);
  useEffect(() => {
    if (window.location.hash == '#login') {
      setVisible(true)
    }


  }, [window.location.hash]);
  const closeCategoriesList = () => {
    document.body.click();
  };


  //search

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  let searchTimeout = null;

  // تابع debounced که جستجو را در ضریبی از 4 کاراکتر انجام می‌دهد
  const handleSearchInput = debounce((query) => {
    if (query.length % 4 === 0 && query.length > 0) {
      searchProduct(query); // جستجو را فراخوانی می‌کنیم
    }
  }, 500); // تاخیر 500 میلی‌ثانیه

  // تغییرات در جعبه جستجو
  const onSearchTextChange = (e) => {
    const value = e.target.value;
    setSearchText(value)
    handleSearchInput(value); // ارسال به debounced
  };
  // تابع جستجو
  const searchProduct = (query) => {
    if (query.trim().length > 0) {
      navigate(`/products?categoryId= &&title=${query}`);
    }
  };

  const itemRenderer = (item) => (
    <div className='p-menuitem-content d-flex align-items-center py-2' style={{ gap: '2em' }} onClick={item.command}>
      <img src={item.icon} alt="" />
      <h6 className='mb-0 text-sm	'>{item.label}</h6>
    </div>
  );

  let items = [
    {
      label: 'حساب کاربری',
      icon: User,
      command: (event) => {
        navigate('/profile')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'سبد خرید',
      icon: BasketIcon,
      command: (event) => {
        navigate('/orders')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'سفارشات',
      icon: Shop,
      command: (event) => {
        navigate('/order-list')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'پرداخت',
      icon: Card,
      command: (event) => {
        navigate('/payment')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'گزارشات مالی',
      icon: Report,
      command: (event) => {
        navigate('/report')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'تیکت',
      icon: Message,
      command: (event) => {
        navigate('/tickets')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'اعلانات',
      icon: Notif,
      command: (event) => {
        navigate('/notification')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'علاقه مندی ها',
      icon: Heart,
      command: (event) => {
        navigate('/favorite')
        menuLeft.current.toggle(event); // بستن منو بعد از ناوبری

      }, // از تابع استفاده کنید
      template: itemRenderer
    },
    {
      label: 'خروج از حساب کاربری',
      icon: Logout,
      command: () => logout(),
      template: itemRenderer
    }
  ];
  const logout = () => {
    localStorage.removeItem("userInfo");
    window.location.href = '/'
  }

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      {/* <PopupDisplay popup={popup} onAllPopupsDismissed={handleAllPopupsDismissed} /> */}

      {/* {loading && <Loader isLoading={loading} />} */}
      <Navbar expand='lg' className='web-nav' >

        <div className={`navbar-menu d-flex align-items-center justify-content-between ${isScrolled ? "fixed-navbar show w-100" : "container"}`} >
          <div className={`d-flex align-items-center justify-content-between   w-100 ${isScrolled ? "container" : ""}`}>
            <Navbar.Collapse id="basic-navbar-nav">
              <img src={Logo} alt="Logo" style={{ marginLeft: '1.5em' }} width={75} onClick={() => { navigate('/') }} />
              <Nav activeKey={location.pathname}>
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-center gap-1' href="/" active={location.pathname === "/"}>خانه</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown active={location.pathname === "/products"} className='[&_.dropdown-menu.show]:!w-auto' title={<div className='d-flex align-items-end'><h6 className='nav-link p-0 mb-0 d-flex align-items-center gap-1' style={{ marginTop: '3px' }}>محصولات</h6>
                    <div style={{ width: '20px', marginRight: '5px' }}>
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668" stroke="#494C50" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                  </div>} id="nav-dropdown">
                    <div style={{ display: "flex" }}>
                      {/* Categories Column */}
                      <div
                        className={`${products.length > 0 ? "border-l-[#00a14b] border-l-[1px]" : ''}`}
                      // onMouseLeave={handleMouseLeaveCategory}
                      >
                        <NavDropdown.Item
                          onMouseEnter={() => handleMouseEnterCategory(' ')}
                          href={`/products?categoryId=`}
                        >
                          <div className={`${hoveredCategory === '' ? "text-[#00a14b] font-bold" : ''}`}>
                            همه محصولات
                          </div>
                        </NavDropdown.Item>
                        {categoriesPackage.map((category, index) => (
                          <NavDropdown.Item
                            key={index}
                            onMouseEnter={() => handleMouseEnterCategory(category.Si)}
                            href={`/products?categoryId=${category.Si}`}
                          >
                            <div className={`${hoveredCategory === category.Si ? "text-[#00a14b] font-bold" : ''}`}>
                              {category.GrpName}
                            </div>
                          </NavDropdown.Item>
                        ))}
                      </div>

                      {/* Products Column */}

                      {productLoading ? (
                        <div
                          className='w-[50vw] flex items-start flex-wrap px-1 h-fit '
                          style={{ overflow: 'auto', maxHeight: '400px' }}
                        >
                          <div className=' row w-100 mx-2'>
                            {/* نمایش ۶ اسکلتون هنگام لود */}
                            {[...Array(12)].map((_, i) => (
                              <div className='col-4 mt-2 px-3 py-2'>
                                <Skeleton height="20px" className=' ' />
                              </div>

                            ))}
                          </div>
                        </div>
                      ) : (products.length > 0 && <div
                        className='w-[50vw] flex items-start flex-wrap px-1 h-fit '
                        style={{ overflow: 'auto', maxHeight: '400px' }}
                      >
                        {products?.map((product, productIndex) => (
                          <Link to={`/product?id=${product.Code}`} onClick={closeCategoriesList} className='mt-2 px-1 py-2 rounded cursor-pointer hover:bg-[#00a14b] text-[#000] hover:text-[#fff] !w-1/3 flex gap-2 ' key={productIndex}>
                            <div className="w-6 h-6 flex justify-center items-center">
                              <img src={product.Pic_A} alt="" className='rounded-sm' />
                            </div>
                            <div className='text-sm text-right title-menu'>
                              {product.KalaName}
                            </div>
                          </Link>
                        ))}
                      </div>
                      )}
                    </div>

                  </NavDropdown>
                </Nav.Item>


                {/* پک پذیرایی */}
                <Nav.Item>
                  <NavDropdown active={location.pathname === "/products-pack"} className='[&_.dropdown-menu.show]:!w-auto' title={<div className='d-flex align-items-end'><h6 className='nav-link p-0 mb-0 d-flex align-items-center gap-1' style={{ marginTop: '3px' }}>پک پذیرایی</h6>
                    <div style={{ width: '20px', marginRight: '5px' }}>
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668" stroke="#494C50" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                  </div>} id="nav-dropdown">
                    <div style={{ display: "flex" }}>
                      {/* Categories Column */}
                      <div
                        className={`${packProducts.length > 0 ? "border-l-[#00a14b] border-l-[1px]" : ''}`}
                      // onMouseLeave={handleMouseLeaveCategory}
                      >
                        {/* <NavDropdown.Item
                          onMouseEnter={() => handleMouseEnterCategory(' ')}
                          href={`/products?categoryId=`}
                        >
                          <div className={`${hoveredCategory === '' ? "text-[#00a14b] font-bold" : ''}`}>
                            همه محصولات
                          </div>
                        </NavDropdown.Item> */}
                        {pack.map((category, index) => (
                          <NavDropdown.Item
                            key={index}
                            onMouseEnter={() => handleMouseEnterPack(category.Si)}
                            href={`/products-pack?categoryId=${category.Si}`}
                          >
                            <div className={`${hoveredPack === category.Si ? "text-[#00a14b] font-bold" : ''}`}>
                              {category.GrpName}
                            </div>
                          </NavDropdown.Item>
                        ))}
                      </div>

                      {/* Products Column */}


                      {productLoading ? (
                        <div
                          className='w-[50vw] flex items-start flex-wrap px-1 h-fit '
                          style={{ overflow: 'auto', maxHeight: '400px' }}
                        >
                          <div className=' row w-100 mx-2'>
                            {/* نمایش ۶ اسکلتون هنگام لود */}
                            {[...Array(12)].map((_, i) => (
                              <div className='col-4 mt-2 px-3 py-2'>
                                <Skeleton height="20px" className=' ' />
                              </div>

                            ))}
                          </div>
                        </div>
                      ) : (packProducts.length > 0 && <div
                        className='w-[50vw] flex items-start flex-wrap px-1 h-fit '
                        style={{ overflow: 'auto', maxHeight: '400px' }}
                      >
                        {packProducts?.map((product, productIndex) => (
                          <Link to={`/product?id=${product.Si}`} onClick={closeCategoriesList} className='mt-2 px-1 py-2 rounded cursor-pointer hover:bg-[#00a14b] text-[#000] hover:text-[#fff] !w-1/3 flex gap-2 ' key={productIndex}>
                            <div className="w-6 h-6 flex justify-center items-center">
                              <img src={product.Pic_A} alt="" className='rounded-sm' />
                            </div>
                            <div className='text-sm text-right title-menu'>
                              {product.KalaName}
                            </div>
                          </Link>
                        ))}
                      </div>
                      )}
                    </div>
                  </NavDropdown>
                </Nav.Item>


                {/* 
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-center gap-1' href="/shop" active={location.pathname === "/shop"}> وبلاگ</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-center gap-1' href="/contact-us" active={location.pathname === "/contact-us"}> ارتباط با فروش</Nav.Link>
                </Nav.Item>

              </Nav>
            </Navbar.Collapse>
            <div>
              <div className='d-flex align-items-center justify-content-start gap-3'>
                <BasketLayout />
                <div className='input-icon border-[#00a14b]' style={{ borderColor: '#00a14b' }}>
                  <input className='form-control' placeholder='جستجو...' value={searchText}
                    onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission
                        navigate(`/products?categoryId= &&title=${e.target.value}`);
                      }
                    }}></input>
                  <button className='btn' onClick={() => { navigate(`/products?categoryId=${'all'}&&title=${searchText}`); }}><img src={Search} alt="" /></button>
                </div>
                <button className='btn btn-primary d-flex align-items-center' onClick={(event) => {
                  if (localStorage.getItem('userInfo')) { menuLeft.current.toggle(event) } else {
                    setVisible(true)
                  }
                }}><img src={Profile} style={{ marginLeft: '3px' }} alt="" />{
                    localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).fullname : 'ورود'
                  }</button>
              </div>
            </div>
          </div>
        </div>
      </Navbar >
      <Menu model={items} popup ref={menuLeft} id="popup_menu_navbar" />
      {/* Mobile Navbar */}
      < Navbar

        className="px-2 bg-body-tertiary mb-3 mobile-nav d-flex align-items-center justify-content-between"
        dir="rtl" // Setting text direction to RTL
      >
        <div className='d-flex align-items-center gap-2'>
          <img src={MenuIcon} alt="Menu" onClick={() => setVisibleRight(true)} />
          <img src={Logo} alt="Logo" width={38} />
        </div>
        <BasketLayout />

      </Navbar >


      <Dialog
        draggable={false}
        visible={visible}
        style={{ width: '40vw' }}
        breakpoints={{ '60vw': '60vw', '80vw': '90vw' }}
        onHide={() => setVisible(false)}
        className='login-dialog'
        dismissableMask
      >
        <div className='text-center'>
          <img src={Logo} alt="" className='mx-auto' width={96} />
          <div className='d-flex align-items-center justify-between mt-3 w-[85%] mx-auto gap-3 max-md:!w-full'>
            <button className={`${sectionLogin == 0 ? 'btn-primary' : 'btn-outline-primary'
              } btn w-50 d-flex align-items-center justify-center gap-2`} onClick={() => { setSectionLogin(0) }}> <img src={sectionLogin == 0 ? Profile : ProfileSolid} alt="" width={20} />ورود</button>
            <button className={`${sectionLogin == 1 ? 'btn-primary' : 'btn-outline-primary'
              } btn w-50 d-flex align-items-center justify-center gap-2`} onClick={() => { setSectionLogin(1) }}> <img src={sectionLogin == 1 ? PersonalCardSolid : PersonalCard} alt="" width={20} />ثبت نام</button>
          </div>


          {sectionLogin == 0 ? (
            <>
              <LoginComponent />
            </>
          ) : (
            <>
              <RegisterComponent />
            </>
          )

          }
        </div>
      </Dialog>

      <Sidebar
        visible={visibleRight}
        onHide={() => setVisibleRight(false)}
        position="right"
        className='menu-sidebar'
        style={{ position: 'relative', width: '80%' }}
      // showCloseIcon={false}
      >
        <Divider />
        <div className='input-icon border-[#00a14b]' style={{ borderColor: '#00a14b' }}>
          <input className='form-control' placeholder='جستجو...' value={searchText}
            onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // Prevent form submission
                navigate(`/products?categoryId= &&title=${e.target.value}`);
              }
            }}></input>
          <button className='btn' onClick={() => { navigate(`/products?categoryId=${'all'}&&title=${searchText}`); }}><img src={Search} alt="" /></button>
        </div>
        <div className='menu-items mt-4'>
          {/* آیتم‌های ثابت */}
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/' }}>
            <img src={location.pathname === "/" ? HomeActive : Home} alt="home" />

            <span style={location.pathname === "/" ? { color: '#00a14b' } : { color: '#4b5563' }}>خانه</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          {/* محصولات با حالت کشویی */}
          <div className='d-flex flex-column mb-3'>
            <div
              className='d-flex align-items-center justify-content-between'
              onClick={() => setIsProductsOpen(!isProductsOpen)} // کلیک برای باز و بسته شدن منو
              style={{ cursor: 'pointer' }}
            >
              <div className='d-flex align-items-center gap-2'>
                <img src={location.pathname === "/products" ? BasketActive : Shop} alt="Products" />
                <span style={location.pathname === "/products" ? { color: '#00a14b' } : { color: '#4b5563' }}>محصولات</span>
              </div>

              <img src={ArrowDown} alt="Expand" style={{ transform: isProductsOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </div>

            {isProductsOpen && (
              <div className="px-4 mt-3">
                <React.Fragment >

                  <a href={`/products?categoryId=`} className="d-flex align-items-start gap-2 mb-2 text-sm	">
                    همه محصولات
                  </a>

                  {/* {index < categories.length - 1 && (
  <hr style={{ color: '#00a14b7a', opacity: '1', margin: '2px' }} />
)} */}
                </React.Fragment>
                {/* <a href="/products" className="d-block mb-2 text-sm	mx-4 " >همه</a> */}
                {categoriesPackage.map((category, index) => (
                  <React.Fragment key={index}>

                    <a href={`/products?categoryId=${category.Si}`} className="d-flex align-items-start gap-2 mb-2 text-sm	">      <img src={category.Pic_A} alt="" width={18} />
                      {category.GrpName}
                    </a>

                    {/* {index < categories.length - 1 && (
                      <hr style={{ color: '#00a14b7a', opacity: '1', margin: '2px' }} />
                    )} */}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />



          {/* پک پذیرایی با حالت کشویی */}
          <div className='d-flex flex-column mb-3'>
            <div
              className='d-flex align-items-center justify-content-between'
              onClick={() => setIsPacksOpen(!isPacksOpen)} // کلیک برای باز و بسته شدن منو
              style={{ cursor: 'pointer' }}
            >
              <div className='d-flex align-items-center gap-2'>
                <img src={location.pathname === "/products-pack" ? BasketActive : Shop} alt="Products" />
                <span style={location.pathname === "/products-pack" ? { color: '#00a14b' } : { color: '#4b5563' }}>پک پذیرایی</span>
              </div>

              <img src={ArrowDown} alt="Expand" style={{ transform: isPacksOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </div>

            {isPacksOpen && (
              <div className="px-4 mt-3">

                {/* <a href="/products" className="d-block mb-2 text-sm	mx-4 " >همه</a> */}
                {pack.map((category, index) => (
                  <React.Fragment key={index}>

                    <a href={`/products?categoryId=${category.Si}`} className="d-flex align-items-start gap-2 mb-2 text-sm	">      <img src={category.Pic_A} alt="" width={18} />
                      {category.GrpName}
                    </a>

                    {/* {index < categories.length - 1 && (
                      <hr style={{ color: '#00a14b7a', opacity: '1', margin: '2px' }} />
                    )} */}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

          {/* سایر آیتم‌ها */}
          {/* <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/branches' }}>
            <img src={Blog} alt="Branches" />
            <span style={location.pathname === "/blog" ? { color: '#00a14b' } : { color: '#4b5563' }}>وبلاگ</span>
          </div> */}
          {/* <hr style={{ color: '#00a14b7a', opacity: '1' }} /> */}

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/contact-us' }}>
            <img src={location.pathname === "/contact-us" ? HeadphoneActive : Headphone} alt="contact-us" />
            <span style={location.pathname === "/contact-us" ? { color: '#00a14b' } : { color: '#4b5563' }}>ارتباط با فروش</span>
          </div>
          <hr style={{ color: '#00a14b7a', opacity: '1' }} />

      
          {localStorage.getItem('userInfo') ? (

            <>
              <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/profile' }}>
                <img src={location.pathname === "/profile" ? UserActive : User} alt="Products" />
                <span style={location.pathname === "/profile" ? { color: '#00a14b' } : { color: '#4b5563' }}>حساب کاربری</span>
              </div>
              <hr style={{ color: '#00a14b7a', opacity: '1' }} />

              <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/order-list' }}>
                <img src={location.pathname === "/order-list" ? BasketActive : Shop} alt="Products" />
                <span style={location.pathname === "/order-list" ? { color: '#00a14b' } : { color: '#4b5563' }}>سفارشات</span>
              </div>
              <hr style={{ color: '#00a14b7a', opacity: '1' }} />

              <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/tickets' }}>
                <img src={location.pathname === "/tickets" ? MessageActive : Message} alt="Products" />
                <span style={location.pathname === "/tickets" ? { color: '#00a14b' } : { color: '#4b5563' }}>تیکت</span>
              </div>
              <hr style={{ color: '#00a14b7a', opacity: '1' }} />
              <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/notification' }}>
                <img src={location.pathname === "/notification" ? NotifActive : Notif} alt="Products" />
                <span style={location.pathname === "/notification" ? { color: '#00a14b' } : { color: '#4b5563' }}>اعلانات</span>
              </div>
              <hr style={{ color: '#00a14b7a', opacity: '1' }} />
              <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/favorite' }}>
                <img src={location.pathname === "/favorite" ? HeartActive : Heart} alt="Products" />
                <span style={location.pathname === "/favorite" ? { color: '#00a14b' } : { color: '#4b5563' }}>علاقه مندی ها</span>
              </div>
              <hr style={{ color: '#00a14b7a', opacity: '1' }} />

              <div className='d-flex align-items-center gap-2 mb-3' onClick={logout}>
                <img src={Logout} alt="Employment" />
                <span>خروج از حساب کاربری</span>
              </div>
            </>
          ) : (
            <>
              <button className='btn btn-primary d-flex align-items-center w-100' onClick={(event) => {
                setVisible(true)
              }}><img src={Profile} style={{ marginLeft: '3px' }} alt="" />{
                  localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).fullname : 'ورود'
                }</button>
            </>
          )}

        </div>
      </Sidebar>

    </>
  );
};

export default NavbarComponent;
